import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: {},
    token: null,
    loading: true
}

const userSlice = createSlice({
    name: "userSlice",
    initialState,
    reducers: {
        saveUserData: (state, action) => {
            state.user = action.payload.user;
            state.token = action.payload.token;
        },
        removeUserData: (state) => {
            localStorage.clear();
            sessionStorage.clear();
            state.loading = true;
            state.token = null;
            state.user = {};
        },
        saveUserLoading: (state, action) => {
            state.loading = action.payload.loading;
        }
    },
});

export const { saveUserData, removeUserData, saveUserLoading } = userSlice.actions;
export default userSlice.reducer;